import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';

import AuthReducer from '../auth/authReducer';
import DashboardReducer from '../dashboard/dashboardReducer';
import TabReducer from '../common/tab/tabReducer';
import UsuarioPerfilReducer from '../usuarioPerfil/usuarioPerfilReducer';
import UsuarioReducer from '../usuario/usuarioReducer';
import GrupoProdutoReducer from '../grupoProduto/grupoProdutoReducer';
import ProdutoReducer from '../produto/produtoReducer';
import ClienteReducer from '../cliente/clienteReducer';
import PedidoReducer from '../pedido/pedidoReducer';

const rootReducer = combineReducers({
	auth: AuthReducer,
	dashboard: DashboardReducer,
	usuarioPerfil: UsuarioPerfilReducer,
	usuario: UsuarioReducer,
	grupoProduto: GrupoProdutoReducer,
	produto: ProdutoReducer,
	cliente: ClienteReducer,
	pedido: PedidoReducer,
    tab: TabReducer,
    form: formReducer,
    toastr: toastrReducer
});

export default rootReducer;

